var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canShowGenesys
    ? _c("div", { staticClass: "rb-genesys" }, [
        _vm.buttonIsVisible && _vm.areScriptsLoaded
          ? _c(
              "button",
              {
                staticClass: "rb-genesys__button",
                on: { click: _vm.openChat },
              },
              [
                _c(
                  "div",
                  { staticClass: "common__icon common__icon--genesys-chat" },
                  [_vm._v("chat genesys")]
                ),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }